import {useInfiniteQuery} from '@tanstack/react-query'
import {useSnackbar} from 'notistack'
import api from 'src/services/api'
import {QueryKeyEnum} from 'src/utilities/enums/QueryKeyEnum'

export default function useCompanies() {
  const {enqueueSnackbar} = useSnackbar()

  const query = useInfiniteQuery({
    retry: 0,
    initialPageParam: 1,
    queryKey: [QueryKeyEnum.COMPANIES],
    queryFn: async ({pageParam: nextPage}) => {
      if (nextPage === -1) throw new Error('No more page to load')

      const response = await api.company.getMany({
        orderBy: {names: 'ASC'},
        pageSize: 100,
      })

      return response.data.data
    },
    getNextPageParam: (lastPage) => {
      const current = lastPage.currentPage
      if (lastPage.entities.length < 20) return -1
      return current + 1
    },
    throwOnError: () => {
      enqueueSnackbar('Todas as empresas já foram carregadas', {variant: 'info'})
      return false
    },
  })

  return query
}
